import { BodyM, Heading2 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { linkBuilder } from '@/components/Link/linkBuilder'
import { CardListWrapper, ListingCardVertical } from '@/components/ListingCardVertical'
import { NoResults } from '@/components/NoResults'
import { useUserNavigation } from '@/context/UserNavigationProvider'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { flexCenter } from '@/shared-styles/styles.css'
import { Listings_Detail } from '@/types/cate-graphql-generated-types'
import { mapListingsIntoCardDataListing } from '@/utils/property-card'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { noResultsWrapper } from '../styles.css'

type Props = {
  isLoading: boolean
  listings: Listings_Detail[]
}

export const ListingsList: React.FC<Props> = ({ isLoading, listings }) => {
  const { lang, t } = useTranslation()
  const router = useRouter()
  const parsedListingsIntoCardData = mapListingsIntoCardDataListing(listings, lang)

  const { returnToLastCityPage } = useUserNavigation()
  if (isLoading) return <></>
  return (
    <>
      <div className={flexCenter}>
        <Heading2>{t('suggested:Suggested_Today_Title')}</Heading2>
      </div>
      <BodyM className={sprinkles({ paddingBottom: '2xl' })} color="greyscale500">
        {t('suggested:Suggested_Today_Description')}
      </BodyM>
      {parsedListingsIntoCardData?.length === 0 ? (
        <div className={noResultsWrapper}>
          <NoResults
            buttonTitle={'suggested:Suggested_NoResults_CTA'}
            description={'suggested:Suggested_NoResults_Description'}
            eventTracking={[GTMEventCategory.SuggestedPage, 'NoResults', 'CTA']}
            title={'suggested:Suggested_NoResults_Title'}
            onClick={returnToLastCityPage}
          />
        </div>
      ) : (
        <CardListWrapper>
          {parsedListingsIntoCardData?.map((listing) => {
            const [country] = (listing.zone?.slug || listing.city).split('/')
            const locale = router.locale === 'en' && country === 'it' ? router.locale : country
            const listingLink = linkBuilder.listingDetail.url(locale as Locale, listing.id)

            return (
              <Link key={listing.id} href={listingLink} locale={false}>
                <a>
                  <ListingCardVertical
                    favouriteEnabled
                    cardData={listing}
                    favoriteButtonGtmTouchpoint={GTMEventCategory.SuggestedPage}
                    onCardClick={() => handleClick(GTMEventCategory.SuggestedPage, 'ListingCard')}
                  />
                </a>
              </Link>
            )
          })}
        </CardListWrapper>
      )}
    </>
  )
}
